// import axios from 'axios';
import QS from 'qs';
import Vue from 'vue';
import host from '../utils/host';
import host2 from '../utils/host2';
import $http from '../utils/http';
//import protobuf from 'protobufjs';
import protoRoot from '../../static/proto/proto';
import { createRouter } from '../router';
let hostname = window.location.hostname;
let _langNum = 3;

if(hostname.indexOf('en') > -1){
    _langNum = 3;
}
if(hostname.indexOf('kr') > -1){
    _langNum = 4;
}
if(hostname.indexOf('th') > -1 || hostname.indexOf('score66') != -1){
    _langNum = 5;
}
if(hostname.indexOf('vn') > -1 || hostname.indexOf('kqbd') != -1){
    _langNum = 6;
}
let commonParam = {
    langNumber: _langNum,//语言标识(公共参。1=简 2=繁 3=英 4=韩 5=泰 6=越 7=日本).
    platform: 4,//平台(公共参。1=Android, 2=iOS, 3=webapp, 4=pc).
    portType: 1,//平台(公共参。1=Android, 2=iOS, 3=webapp, 4=pc).
    sportType: 1,//1足球2篮球(非公共参)
}
export function socketRes(data) {
    var buf = new Uint8Array(data);

    var modelResponse = protoRoot.lookupType("model.Response");
    var response = modelResponse.decode(buf);

    return response;
}

// 比分websocket开启
export function footballListOpen(_$socket, ver) {
    if (typeof (window) == 'undefined') {
        return;
    }

    var subscribe = {
        type: 101,
        scoreVersion: ver, //这个版本号从API那里拿，然后回传
    };
    subscribe = { ...commonParam, ...subscribe}
    var lookType = protoRoot.lookupType('model.Subscribe');
    var subEncode = lookType.create(subscribe);
    var buffer = lookType.encode(subEncode).finish();
    //console.log('开启', buffer)
    _$socket.send(buffer);
    //console.log("发送listOpen", subscribe);
};

export function getSocket(_this, obj) {
    if (typeof (window) == 'undefined') {
        return;
    }
    var subscribe = {
        type: 111,
        //scoreVersion: ver, //这个版本号从API那里拿，然后回传
        matchId: '',
    };
    subscribe = { ...commonParam, ...subscribe, ...obj }
    var lookType = protoRoot.lookupType('model.Subscribe');
    var subEncode = lookType.create(subscribe);
    var buffer = lookType.encode(subEncode).finish();
    //console.log('开启', buffer)
    _this.$socket.send(buffer);
    //console.log("发送listOpen", subscribe);
};

export function getSocketFootballListUpdate(data) {
    var dataBuf = data;
    var modelData = protoRoot.lookupType("model.FootballListUpdate");
    var decData = modelData.decode(dataBuf);

    return decData;
};
//Socket更新包二进制转换
export function getSocketUpdate(data, name) {
    var dataBuf = data;
    var modelData = protoRoot.lookupType("model." + name);
    var decData = modelData.decode(dataBuf);

    return decData;
};

// 获取比分列表
export function getDataList(params) {
    const url = host2() + 'match/version/1_0/footballMatch/listByDate';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballList");
            var footballData = modelData.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 获取比分指数差异
export function getListLuckDiff(params) {
    const url = host2() + 'match/version/1_0/footballMatch/listLuckDiff';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballList");
            var footballData = modelData.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 获取关注指数差异
export function getListFollowLuckDiff(params) {
    const url = host() + 'match/version/1_0/footballMatch/listFollowLuckDiff';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballList");
            var footballData = modelData.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 获取用户信息, 可判断是否登录
export function getUser(params) {
    const url = host() + 'user/version/1_0/getUser';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state == 400 || response.state == 403) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.UserInfoItem");
            var footballData = modelData.decode(dataBuf);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 邮箱登录
export function getEmailLogin(params) {
    const url = host() + 'user/version/1_0/login/email';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state == 400) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.UserInfoItem");
            var footballData = modelData.decode(dataBuf);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 邮箱注册
export function getEmailSignUp(params) {
    const url = host() + 'user/version/1_0/register/email';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 忘记密码
export function getForgotPwd(params) {
    const url = host() + 'user/version/1_0/forgetPwd';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 重设密码
export function getResetPwd(params) {
    const url = host() + 'user/version/1_0/resetPwd';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 修改密码
export function getResetPassword(params) {
    const url = host() + 'user/version/1_0/resetPassword';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 第三方登录
// apple登录
export function getAppleLogin(params) {
    const url = host() + 'user/version/1_0/login/oauth/apple_callback';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};
// google、facebook登录: 1=Google 2=Facebook
export function getThirdLogin(params) {
    const url = host() + 'user/version/1_0/login/oauth/callback';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 比赛 添加/删除关注
export function getFollowMatch(params) {
    const url = host() + 'match/version/1_0/footballMatch/follow';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 联赛 添加/删除关注
export function getFollowLeague(params) {
    const url = host() + 'dataBase/version/1_0/footballLeague/follow';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 获取关注列表
export function getFavoritesList(params) {
    const url = host() + 'match/version/1_0/footballMatch/listFollow';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            console.log(response)

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballFollowList");
            var footballData = modelData.decode(dataBuf);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 获取新闻最新10条
export function getNewsListLast(params) {
    const url = host() + 'news/version/1_0/listLast';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.NewsListLast");
            var footballData = modelData.decode(dataBuf);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 获取广告列表
export function getListAd(obj) {
    var params = {
        pageId: 1,
        userToken: '',
    };
    params = { ...commonParam, ...params, ...obj }
    const url = host() + 'webAd/version/1_0/listAd';

    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.WebAd");
            var footballData = modelData.decode(dataBuf);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 邮箱订阅
export function getEmailSubscribe(params) {
    const url = host() + 'user/version/1_0/subscribe/email';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};
// 广告点击量
export function getAdHits(obj) {
    var params = {
        id: 1,
        userToken: '',
    };
    params = { ...commonParam, ...params, ...obj }

    const url = host() + 'webAd/version/1_0/hits';

    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};
// 获取seo配置
export function getSEO(obj) {
    var params = {
        type: 1,
        userToken: '',
    };
    params = { ...commonParam, ...params, ...obj }
    
    const url = host() + 'setting/version/1_0/seo';

    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.Seo");
            var footballData = modelData.decode(dataBuf);
            response.data = footballData;
            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

/* 比赛内页 */
export function getMatchInfo(params) {
    const url = host2() + 'match/version/1_0/footballMatch/matchInfo';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            // console.log("getMatchInfo-response", response);
            if (response.state == 400) {
                createRouter().push({path: '/404'})
            }
            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("model.FootballMatchInfo");
           
            var footballList = modelFootballList.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
// 概况
export function getMatchSummary(params) {
    const url = host2() + 'match/version/1_0/footballMatch/summary';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("model.FootballMatchSummary");
            var footballList = modelFootballList.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
//事件统计
export function getMatchStats(params) {
    const url = host2() + 'match/version/1_0/footballMatch/stats';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("model.FootballMatchStats");
            var footballList = modelFootballList.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
//阵容
export function getMatchLineup(params) {
    const url = host2() + 'match/version/1_0/footballMatch/lineup';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("model.FootballMatchLineup");
            var footballList = modelFootballList.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
//事件直播
export function getMatchEventLive(params) {
    const url = host2() + 'match/version/1_0/footballMatch/eventLive';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("model.FootballMatchEvent");
            var footballList = modelFootballList.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
//0DDS
export function getMatchLuckList(params) {
    const url = host2() + 'match/version/1_0/footballMatch/luckList';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("model.FootballMatchLuck");
            var footballList = modelFootballList.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
//ODDS-公司列表
export function getMatchLuckCompany(params) {
    const url = host2() + 'match/version/1_0/footballMatch/luckCompany';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("model.LuckCompanyList");
            var footballList = modelFootballList.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
//ODDS-日志
export function getMatchLuckLog(params) {
    const url = host2() + 'match/version/1_0/footballMatch/luckLog';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("FootballMatchLuckLog");
            var footballList = modelFootballList.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
//积分表
export function getMatchStadings(params) {
    const url = host2() + 'match/version/1_0/footballMatch/standingByMid';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("FootballMatchStanding");
            var footballList = modelFootballList.decode(dataBuf);
            // console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
//H2H
export function getMatchH2H(params) {
    const url = host2() + 'match/version/1_0/footballMatch/h2h';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            console.log("response", response);

            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("FootballMatchH2h");
            var footballList = modelFootballList.decode(dataBuf);
            console.log("FootballMatchH2h", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
//Prediction
export function getMatchPrediction(params) {
    const url = host2() + 'match/version/1_0/footballMatch/prediction';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("FootballMatchPrediction");
            var footballList = modelFootballList.decode(dataBuf);
            // console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
/* 资料库 */
// 联赛列表
export function getLeagueList(params) {
    const url = host2() + 'dataBase/version/1_0/footballLeague/all';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            var dataBuf = response.data.value;
            var modelFootballLeagueAll = protoRoot.lookupType("model.FootballLeagueAll");
            var leagueList = modelFootballLeagueAll.decode(dataBuf);
            response.data = leagueList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 联赛信息
export function getLeagueInfo(params) {
    const url = host2() + 'dataBase/version/1_0/footballLeague/info';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            if (response.state == 400) {
                createRouter().push({path: '/404'})
            }

            var dataBuf = response.data.value;
            var modelFootballLeagueInfo = protoRoot.lookupType("model.FootballLeagueInfo");
            var leagueInfo = modelFootballLeagueInfo.decode(dataBuf);
            response.data = leagueInfo;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// Points
export function getPointsData(params) {
    const url = host2() + 'dataBase/version/1_0/footballLeague/standing';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            var dataBuf = response.data.value;
            var modelFootballLeagueStandings = protoRoot.lookupType("model.FootballMatchStanding");
            var pointsData = modelFootballLeagueStandings.decode(dataBuf);
            response.data = pointsData;
            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// AH
export function getAHData(params) {
    const url = host2() + 'dataBase/version/1_0/footballLeague/standingAH';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            var dataBuf = response.data.value;
            var modelFootballLeagueStandingsAH = protoRoot.lookupType("model.FootballLeagueStandingsAH");
            var pointsData = modelFootballLeagueStandingsAH.decode(dataBuf);
            response.data = pointsData;
            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// Fixtures
export function getFixturesData(params) {
    const url = host2() + 'dataBase/version/1_0/footballLeague/fixture';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            var dataBuf = response.data.value;
            var modelFootballLeagueFixture = protoRoot.lookupType("model.FootballLeagueFixture");
            var pointsData = modelFootballLeagueFixture.decode(dataBuf);
            response.data = pointsData;
            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

/* 资料库 */


/* 新闻 */
// 新闻-分类
export function getNewsCategory(params) {
    const url = host() + 'news/version/1_0/listCategory';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            var dataBuf = response.data.value;
            var modelFootballLeagueFixture = protoRoot.lookupType("model.CategoryList");
            var pointsData = modelFootballLeagueFixture.decode(dataBuf);
            response.data = pointsData;
            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 新闻-列表
export function getListNews(params) {
    const url = host() + 'news/version/1_0/listNews';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            var dataBuf = response.data.value;
            var modelFootballLeagueFixture = protoRoot.lookupType("model.NewsList");
            var pointsData = modelFootballLeagueFixture.decode(dataBuf);
            response.data = pointsData;
            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 新闻-详细
export function getNewsDetail(params) {
    const url = host() + 'news/version/1_0/detail';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            // console.log(response,'response')
            if (response.state == 400) {
                createRouter().push({path: '/404'})
            }
            var dataBuf = response.data.value;
            var modelFootballLeagueFixture = protoRoot.lookupType("model.News");
            var pointsData = modelFootballLeagueFixture.decode(dataBuf);
            response.data = pointsData;
            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 新闻点击量
export function getNewsInfoHits(obj) {
    var params = {
        id: 1,
        userToken: '',
    };
    params = { ...commonParam, ...params, ...obj }

    const url = host() + 'news/version/1_0/hits';

    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};
/* 新闻 */

// 联赛-关注列表
export function getLeagueListFollow(params) {
    const url = host() + 'dataBase/version/1_0/footballLeague/listFollow';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state != 200) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballLeagueList");
            var footballData = modelData.decode(dataBuf);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 联赛-热门列表
export function getLeagueListHot(params) {
    const url = host() + 'dataBase/version/1_0/footballLeague/listHot';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state != 200) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballLeagueList");
            var footballData = modelData.decode(dataBuf);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 比赛关注ID列表
export function getListFollowIds(params) {
    const url = host() + 'match/version/1_0/footballMatch/listFollowIds';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state != 200) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballList");
            var footballData = modelData.decode(dataBuf);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
/* 比赛内页-是否关注 */
export function getMatchInfoIsFollow(params) {
    const url = host() + 'match/version/1_0/footballMatch/isFollow';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            // console.log("getMatchInfo-response", response);
            if (response.state != 200) {
                return resolve(response);
            }
            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("model.FootballMatchInfo");
           
            var footballList = modelFootballList.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
/* 联赛-是否关注 */
export function getLeagueInfoIsFollow(params) {
    const url = host() + 'dataBase/version/1_0/footballLeague/isFollow';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            // console.log("getMatchInfo-response", response);
            if (response.state != 200) {
                return resolve(response);
            }
            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("model.FootballLeagueInfo");
           
            var footballList = modelFootballList.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};
// 联赛-默认热门
export function getLeagueDefaultHot(params) {
    const url = host() + 'dataBase/version/1_0/footballLeague/defaultHot';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state != 200) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballLeague");
            var footballData = modelData.decode(dataBuf);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 邮箱订阅文案
export function getSubscribeEmailIntro(params) {
    const url = host() + 'user/version/1_0/subscribe/emailIntro';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state != 200) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.Intro");
            var footballData = modelData.decode(dataBuf);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 获取公司指数列表
export function getListLuckByCom(params) {
    const url = host2() + 'match/version/1_0/footballMatch/listLuckByCom';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballList");
            var footballData = modelData.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 获取关注列表odds
export function getListFollowLuck(params) {
    const url = host() + 'match/version/1_0/footballMatch/listFollowLuck';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballList");
            var footballData = modelData.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};


// WEBPACK FOOTER //
// ./src/api/api.js